import script from "./CRM01_010RPT.vue?vue&type=script&setup=true&lang=js"
export * from "./CRM01_010RPT.vue?vue&type=script&setup=true&lang=js"

import "./CRM01_010RPT.vue?vue&type=style&index=0&id=50b4fe13&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50b4fe13"]])

export default __exports__